/*
module.exports = {
  home: {
    title: '首页',
    message: '欢迎进入中央周边平台',
    welcome:'欢迎您，',
    signOut:'退出登录',
    systemSettings:'系统设置',
    changePassword:'密码修改',
    departmentSwitch:'切换部门',
    prompt:'提示',
    outMsg:'真的要注销登录吗 ?',
    errorTitle:'错误',
    searchMenu:'搜索菜单',
    welcomeBack:'欢迎回来',
    welcomeTitle:'欢迎',
    loginFailed:'登陆失败',
  },
  page:{
    total:' 共 ',
    article:' 条 ',
  }
}*/
